import { Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import { AppComponentBase } from '@shared/app-component-base';
import { ClinicaMedicaPacienteVipServiceProxy, PacienteDto, ProfissionalAcessoPacienteVipDto, ProfissionalSaudeDto, ProfissionalSaudeServiceProxy, UpdateClinicaMedicaPacienteVipDto } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-edit-paciente-vip',
  templateUrl: './edit-paciente-vip.component.html',
  styleUrls: ['./edit-paciente-vip.component.scss']
})
export class EditPacienteVipComponent extends AppComponentBase implements OnInit {
  public isClinica: boolean = false;
  public clinicaId: string;
  public paciente: PacienteDto;
  public pacienteAcesso: UpdateClinicaMedicaPacienteVipDto;
  public profissionaisFiltrados: ProfissionalSaudeDto[] = [];
  public profissionais: ProfissionalSaudeDto[] = [];
  public profissionaisAdicionados: ProfissionalSaudeDto[] = [];
  public profissionaisRemovidos: ProfissionalSaudeDto[] = [];
  public profissionaisSelecionados: ProfissionalSaudeDto[] = [];
  public nomeMedico: string = "";
  @Output() onSave = new EventEmitter<any>();

  constructor(
    inject: Injector,
    private readonly _clinicaPacienteVipService: ClinicaMedicaPacienteVipServiceProxy,
    private readonly _profisionalService: ProfissionalSaudeServiceProxy,
    public bsModalRef: BsModalRef,
  ) {
    super(inject)
  }

  ngOnInit(): void {
    this.profissionaisFiltrados = [];
    this.profissionais = [];
    this.profissionaisAdicionados = [];
    this.profissionaisRemovidos = [];
    this.profissionaisSelecionados = [];
    this.pacienteAcesso.novosProfissionaisComAcesso = [];
    this.pacienteAcesso.profissionaisComAcessoRemovidos = [];
    this.getProfissionais();
  }

  protected save(): void {
    if (!this.pacienteAcesso.profissionalResponsavelId) {
      abp.notify.info("Informe o profissional responsável!");
      return;
    }
    abp.ui.setBusy();
    this.pacienteAcesso.profissionaisComAcesso = [];
    this._clinicaPacienteVipService.updatePacienteVipAcessos(this.pacienteAcesso).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      abp.notify.success("Dados alterados com sucesso!");
      this.onSave.emit();
      this.bsModalRef.hide();
    })
  }

  protected buscarMedico(event: Event): void {
    const nome = (event.target as HTMLInputElement).value;
    if (!nome) {
      this.profissionaisFiltrados = [];
    } else {
      this.profissionaisFiltrados = this.profissionais
        .filter(x => x.nome.toLowerCase().includes(nome.toLowerCase()))
        .filter(x => this.profissionaisSelecionados.every(y => y.id !== x.id));
    }
  }

  protected insertProfissional(profissional: ProfissionalSaudeDto): void {
    if (this.profissionaisSelecionados.some(x => x.id === profissional.id)) return;

    this.profissionaisSelecionados.push(profissional);
    this.pacienteAcesso.profissionaisComAcessoRemovidos = [...this.pacienteAcesso.profissionaisComAcessoRemovidos.filter(x => x.profissionalSaudeId !== profissional.id)];

    if (this.pacienteAcesso.profissionaisComAcesso.some(x => x.profissionalSaudeId === profissional.id)) return;

    const novoProfissional = new ProfissionalAcessoPacienteVipDto();
    novoProfissional.clinicaMedicaPacienteVipId = this.pacienteAcesso.id;
    novoProfissional.profissionalSaudeId = profissional.id;

    this.pacienteAcesso.novosProfissionaisComAcesso.push(novoProfissional);
  }

  protected removeProfissional(profissional: ProfissionalSaudeDto): void {
    abp.message.confirm(`Deseja remover o acesso do(a) profissional ${profissional.nome}?`, "Atenção", (option) => {
      if (option) {
        this.profissionaisSelecionados = [...this.profissionaisSelecionados.filter(x => x.id !== profissional.id)];
        const profissionalRemovido = this.pacienteAcesso.profissionaisComAcesso.find(x => x.profissionalSaudeId === profissional.id);
        if (profissionalRemovido)
          this.pacienteAcesso.profissionaisComAcessoRemovidos.push(profissionalRemovido);

        this.pacienteAcesso.novosProfissionaisComAcesso = [...this.pacienteAcesso.novosProfissionaisComAcesso.filter(x => x.profissionalSaudeId !== profissional.id)];
        if(profissional.id == this.pacienteAcesso.profissionalResponsavelId) this.pacienteAcesso.profissionalResponsavelId = undefined;
      }
    });
  }

  protected removerStatusVip(): void {
    abp.message.confirm(`Deseja mesmo remover o status de Vip do(a) paceinte ${this.paciente.nome}?`, null, (option) => {
      if (option) {
        abp.ui.setBusy();
        this._clinicaPacienteVipService.delete(this.pacienteAcesso.id).pipe(
          finalize(() => {
            abp.ui.clearBusy();
          })
        ).subscribe(() => {
          abp.notify.success("Dados alterados com sucesso!");
          this.onSave.emit();
          this.bsModalRef.hide();
        })
      }
    })
  }

  private getProfissionais() {
    abp.ui.setBusy();
    this._profisionalService.getProfissionais(this.appSession.clinicaId ?? this.clinicaId).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.profissionais = result.filter(x => x.id != this.pacienteAcesso.profissionalResponsavelId);
      this.profissionaisFiltrados = this.profissionais = result.filter(x =>
        x.id !== this.pacienteAcesso.profissionalResponsavelId &&
        !this.pacienteAcesso.profissionaisComAcesso.some(y => y.profissionalSaudeId === x.id)
      );
      if (this.pacienteAcesso.profissionaisComAcesso.length > 0) {
        this.profissionaisSelecionados = [...result.filter(x =>
          this.pacienteAcesso.profissionaisComAcesso.some(y => y.profissionalSaudeId === x.id)
        )];
      }
    })
  }

  protected setProfissionalResponsavel(profissional: ProfissionalSaudeDto): void {
    if (this.pacienteAcesso.profissionalResponsavelId == profissional.id) {
      this.pacienteAcesso.profissionalResponsavelId = undefined;
      return;
    } else {
      abp.message.confirm(`Deseja definir o(a) profissional ${profissional.nome} como reponsável pelo paciente?`, "", (option) => {
        if (option) {
          this.pacienteAcesso.profissionalResponsavelId = profissional.id;
        }
      });
    }

  }
}
